var styles = {"menuLink":"navkit__Dropdown__menuLink","isLink":"navkit__Dropdown__isLink","container":"navkit__Dropdown__container","isPaddingless":"navkit__Dropdown__isPaddingless"};

export { styles as default };
